<ng-container *transloco="let t;">
  <div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{ t('Select template modal title - (Select template modal) - Select
      template') }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body select-template-box-body border-bottom p-50" tabindex="0" ngbAutofocus>
    <app-select-template-box></app-select-template-box>
  </div>
</ng-container>